home = {};

home = {
    init: function () {
        home.loadMainCarousel();
        home.loadOtherCarousel();


        let $divDesc = $('#read-more.home');

        if ($(window).width() > 767) {
            console.log('Read-more: ' + $divDesc.height())

            if ($divDesc.height() > 375) {
                $divDesc.removeClass('showAll');
                $('.read-more').removeClass('hidden');
            }
        }
    },
    loadMainCarousel: function () {
        let $mainCarousel = $('.js-homeMainCarousel');

        $mainCarousel.on('init', function () {
            $mainCarousel.addClass('isLoaded');
        });

        $mainCarousel.slick({
            arrows: false,
            dots: false,
            autoplay: true,
            autoplaySpeed: 4000,
            infinite: true,
            pauseOnHover: false,
            speed: 400,
            fade: true,
            asNavFor: '.js-homeOtherCarousel',
            appendArrows: '.js-topSectionArrows',
            responsive: [
                {
                    breakpoint: 911,
                    settings: {
                        dots: true
                    }
                }
            ]
        });

        $mainCarousel.on('beforeChange', function (e, slick, currentSlide, nextSlide) {
            $('.js-homeOtherCarousel').slick('slickGoTo', nextSlide);

            let currentClass = 'i-' + currentSlide;
            let nextClass = 'i-' + nextSlide;
            $('.slick-dots').removeClass(currentClass).addClass(nextClass);
        });

    },
    loadOtherCarousel: function () {
        let $otherCarousel = $('.js-homeOtherCarousel');

        $otherCarousel.on('init', function () {
            $otherCarousel.addClass('isLoaded');
        });

        $otherCarousel.slick({
            arrows: false,
            dots: true,
            infinite: false,
            speed: 400,
            draggable: false,
            focusOnSelect: true,
            asNavFor: '.js-homeMainCarousel'
        });
    },

    moveInterviewItem: function (elem, e, position) {
        let $elem = $(elem);
        let $image = $elem.find('.item-image-wrapper');

        if (position === 'normal') {
            posX = 0;
            posY = 0;
        } else {
            let relX = e.pageX - $elem.offset().left;
            let relY = e.pageY - $elem.offset().top;

            posX = (relX - $elem.width()/2) / $elem.width();
            posY = (relY - $elem.height()/2) / $elem.height();
        }

        // Animate item
        window.GSAP.TweenMax.to($elem, .4, {
            ease: window.GSAP.Back.easeOut.config(1),
            x: posX * 2.5,
            y: posY * 2.5
        });

        // Animate image
        window.GSAP.TweenMax.to($image, .4, {
            ease: window.GSAP.Back.easeOut.config(1),
            x: posX * 4,
            y: posY * 2
        });
    },
    moveRequirementImageItem: function (elem, e, position) {
        let $elem = $(elem);
        let $mainImage = $elem.find('.main-image');
        let $sun = $elem.find('.sun-image');
        let $country = $elem.find('.country-image');

        if (position === 'normal') {
            posX = 0;
            posY = 0;

            $elem.removeClass('hovering');
        } else {
            let relX = e.pageX - $mainImage.offset().left;
            let relY = e.pageY - $mainImage.offset().top;

            posX = (relX - $mainImage.width()/2) / $mainImage.width();
            posY = (relY - $mainImage.height()/2) / $mainImage.height();
        
            $elem.addClass('hovering');
        }

        // Animate item
        window.GSAP.TweenMax.to($mainImage, .4, {
            ease: window.GSAP.Back.easeOut.config(1),
            x: posX * 17,
            y: posY * 17
        });
        // Animate sun
        window.GSAP.TweenMax.to($sun, .4, {
            ease: window.GSAP.Back.easeOut.config(1),
            x: posX * 100,
            y: posY * 100
        });
        // Animate country
        window.GSAP.TweenMax.to($country, .4, {
            ease: window.GSAP.Back.easeOut.config(1),
            x: posX * -60,
            y: posY * -60
        });
    },
    showElementsOnScroll: function () {
        let margin = window.matchMedia("(max-width: 768px)") ? -300 : -100;
        let $moveSunElements = $('.js-moveSun:not(.showSun)');

        $moveSunElements.each((index, mvSun) => {
            let elementPosY = parseInt($(mvSun).offset().top);
            let scrolled = parseInt($(window).scrollTop()) + parseInt($(window).height() + margin);
            let delay = 200;

            if (elementPosY < scrolled) {
                setTimeout(function () {
                    $(mvSun).addClass('showSun');
                }, index * 100 + delay);
            }
        });

        let $showElements = $('.js-showElement:not(.isVisible)');

        $showElements.each((index, elem) => {
            let elementPosY = parseInt($(elem).offset().top);
            let scrolled = parseInt($(window).scrollTop()) + parseInt($(window).height() + margin);
            let delay = 200;

            if (elementPosY < scrolled) {
                setTimeout(function () {
                    $(elem).addClass('isVisible');
                }, index * 100 + delay);
            }
        });
    },
    toggleText: function () {
        $text = $('#read-more');
        $readMore = $('.read-more');
        $dataLess = $readMore.attr('data-less');
        $dataMore = $readMore.attr('data-more');

        if (!$text.hasClass('showAll')){
            $text.addClass('showAll');
            $readMore.addClass('less');
            $readMore.html($dataLess)
        } else {
            $readMore.html($dataMore)
            $text.removeClass('showAll');
            $readMore.removeClass('less');
        }

    },
    binds: function () {
        $('.js-interviewsCarousel').on('mousemove', '.item', function (e) { home.moveInterviewItem(this, e, 'pointer'); });
        $('.js-interviewsCarousel').on('mouseleave', '.item', function (e) { home.moveInterviewItem(this, e, 'normal'); });

        $('.js-requirementsImages').on('mousemove', '.requirements-image-item', function (e) { home.moveRequirementImageItem(this, e, 'pointer'); });
        $('.js-requirementsImages').on('mouseleave', '.requirements-image-item', function (e) { home.moveRequirementImageItem(this, e, 'normal'); });

        $('.js-toggleText').on('click', this.toggleText);

        $(window).on('scroll', this.showElementsOnScroll);

        $('.item-other a').on('click', function (e) {
            const $link = $(this);
            const targetUrl = $link.attr('href');

			console.log('clickeddd');

            if (!targetUrl || targetUrl === '#') {
                return;
            }

            e.preventDefault();

            setTimeout(function () {
                window.location.href = targetUrl;
				console.log('gogogog');
            }, 300);
        });
    }
};

$(document).ready(function () {
    home.binds();
    home.init();
});